<template>
  <table
    class="pricing-tiers"
    :class="{noActive : noActiveState === true}"
    :align="tableAlignment"
  >
    <tr
      v-for="(item, index) in priceItems"
      :key="index"
      :class="tableClass(index)"
    >
      <td class="quantity">
        {{ item.tierQuantity }}
      </td>
      <td class="price">
        <span class="mdi mdi-currency-eur" />{{ isMsrp === true ? item.msrp.toFixed(2) : item.price.toFixed(2) }}
      </td>
    </tr>
  </table>
</template>

<script>
  import productService from '@/services/productService'

  export default {
    name: 'PricingTable',
    props: {
      priceItems: {
        type: Array,
        required: true,
        default: null,
      },
      activeSubscriptionCount: {
        type: Number,
        required: false,
        default: 0,
      },
      isMsrp: {
        type: Boolean,
        required: false,
        default: false,
      },
      noActiveState: {
        type: Boolean,
        required: false,
        default: false,
      },
      align: {
        type: String,
        required: false,
        default: '',
      },
    },
    data: () => ({
    }),
    computed: {
      tableAlignment () {
        return this.align ? this.align : ''
      },
      activePriceItemIndex () {
        return productService.activePriceItemIndex(this.priceItems, this.activeSubscriptionCount)
      },
    },
    mounted: function () {
    },
    methods: {
      tableClass (index) {
        return 'ml-3 material' +
          (index === this.activePriceItemIndex ? ' active' : '')
      },
    },
  }
</script>

<style lang="scss">
.pricing-tiers{
  &.noActive{
    color:black;
  }
  color:lightgray;
  text-align: right;
  .active{
    color: black
  }
  .price{
    padding-left: 10px;
  }
}
</style>
